/**
 * The guest value-sheet popover under the account pill has two variants: "free" (the pitch,
 * for a first-time visitor with no local history) and "keep" (loss-aversion framing, for a
 * visitor who already has recent searches and/or a viewed job on this device). Kept as a pure
 * function so the selection rule is unit-testable without rendering the popover.
 */
export type ValueSheetVariant = 'free' | 'keep';

export function resolveValueSheetVariant(hasRecentSearches: boolean, hasViewedJob: boolean): ValueSheetVariant {
  return hasRecentSearches || hasViewedJob ? 'keep' : 'free';
}
